<template>
  <div class="crop-group" v-if="group.items.length">
    <ratings v-if="group.rating" :rating="group.rating" :label="group.label" />
    <h2 v-if="group.title" class="title" v-text="group.title"></h2>
    <div v-for="(category, catIndex) in subcategories" :key="catIndex" class="crop-cards">
      <div class="crop-category">
        <h3 class="title" :class="{'collapsed': collapsed.includes(catIndex)}" @click="handleCollapse(catIndex)">{{ category.name | pluralize }}</h3>
        <div v-show="!collapsed.includes(catIndex)">
          <crop-card
            v-for="(crop, index) in category.items"
            :class="{'is-active': crop === activeCrop}"
            :key="group.label + index"
            :crop="crop"
            @selected="handleSelected"
            @removed="$emit('removed',crop)"></crop-card>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import CropCard from '@/components/CropCard'
import Ratings from '@/components/Ratings'
export default {
  props: ['group', 'activeCrop'],
  data () {
    return {
      collapsed: []
    }
  },
  components: {
    'crop-card': CropCard,
    'ratings': Ratings
  },
  methods: {
    handleSelected (crop) {
      this.$emit('selected', {
        crop: crop,
        rating: this.group.rating
      })
    },
    handleCollapse (collapsedIndex) {
      let index = this.collapsed.indexOf(collapsedIndex)
      let collapsed = this.collapsed
      if (index === -1) {
        collapsed.push(collapsedIndex)
      } else {
        collapsed.splice(index, 1)
      }
      this.collapsed = collapsed
    }
  },
  filters: {
    pluralize: function (value) {
      // adjust for pluralized version of name, which we can't use in the matching below
      let plural = 's'
      if (value === 'Grass') {
        plural = 'es'
      }
      if (value === 'Broad') {
        plural = 'leaves'
      }
      return value + plural
    }
  },
  computed: {
    subcategories () {
      let categories = [
        {
          name: 'Brassica',
          items: []
        },
        {
          name: 'Legume',
          items: []
        },
        {
          name: 'Grass',
          items: []
        },
        {
          name: 'Broad',
          items: []
        }
      ]
      categories.forEach((category, index) => {
        this.group.items.forEach((crop, cropIndex) => {
          if (crop.class.indexOf(category.name) > -1) {
            categories[index].items.push(crop)
          }
        })
      })
      // filter out empty categories
      let finalCategories = []
      categories.forEach((category, index) => {
        if (category.items.length) {
          finalCategories.push(category)
        }
      })
      return finalCategories
    }
  }
}
</script>
<style lang="scss">
  .crop-group{
    margin: 0 0 30px;
    background: $color-dark-white;
    border-radius: 3px;
    padding-top: 30px;
    .title{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 0;
      line-height: 1.2;
      color: $color-dark-green;
      padding: 0 30px;
      @include media-breakpoint-up(md){
        font-size: 30px;
        line-height: 1;
      }
    }
  }
  .crop-cards{
    &:last-child{
      border-radius: 0px 0px 3px 3px;
      .crop-category .title.collapsed,
      .crop-category .crop-card:last-child{
        border: none;
        border-radius: 0px 0px 3px 3px;
      }
    }
  }
  .crop-category{
    .title{
      color: $color-dark-green;
      font-size: 22px;
      line-height: 78px;
      font-weight: 600;
      padding: 10px 0;
      border-bottom: solid 1px #D8DCCC;
      cursor: pointer;
      &.collapsed{
        &::after {
          transform: rotate(180deg);
        }
      }
      &::after{
        content: '';
        width: 14px;
        height: 12px;
        margin-left: 6px;
        background: url('/assets/caret.svg') no-repeat center center;
        background-size: 100% auto;
        display: inline-block;
        transition: .2s;
      }
    }
  }
</style>
